import api from "./utils/api";
import general from "./utils/general";
import Main from "./pages/Main";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
import LandingPage from "./pages/LandingPage";
import LandingPagePtBr from "./pages/LandingPage/ptbr";
import Register from "./pages/Register";

export default [
    {
        path: "/*",
        Component: NotFound,
    },
    {
        path: "/",
        Component: general.checkAuth() ? Main : LandingPage,
        exact: true
    },
    {
        path: "/br",
        Component: general.checkAuth() ? Main : LandingPagePtBr,
        exact: true
    },
    {
        path: "/login",
        Component: general.checkAuth() ? Main : Login,
        exact: true
    },
    {
        path: "/register",
        Component: general.checkAuth() ? Main : Register,
        exact: true
    }
]